module.exports = __webpack_public_path__ + "img/synthesis_popup_hint.b661619f.png";